import React from 'react'
import CardProjeto from 'componentes/CardProjeto';
import styles from './ListaProjetos.module.css';
import cinetag from './cinetag.png';
import context from "./context-api.png";
import space from './space.png';
import cep from './buscaCep.png';
import secreto from './secreto.png'
import boracodar from './boracodar.png'

export default function ListaProjetos() {
    return (
        <ul className={styles.lista}>
            <CardProjeto link={'https://cinetag-iota.vercel.app/'} nome={'Cinetag'} texto={"Projeto feito com reactjs, javascript, css, html."} imagem={cinetag} />
            <CardProjeto link={'https://context-api-pied.vercel.app/'} nome={'Context-API'} texto={"Projeto feito para aprender a fazer hooks personalizados e contextos."} imagem={context} />
            <CardProjeto link={'https://alura-space-red.vercel.app/'} nome={'Alura-Space'} texto={"Projeto feito durante o curso: React lidando com arquivos estáticos."} imagem={space} />
            <CardProjeto link={'https://busca-cep-eight.vercel.app/'} nome={'BuscaCep'} texto={"Projeto pessoal desenvolvido para entender melhor react e o uso de API's."} imagem={cep} />
            <CardProjeto link={'https://numero-secreto-pink.vercel.app/'} nome={'Número Secreto'} texto={"Projeto realizado utilizando API web speech, para aprender a tratar promises."} imagem={secreto} />
            <CardProjeto link={'https://bora-codar-umber.vercel.app/'} nome={'Bora Codar'} texto={"Projeto feito para realizar os desafios do 'Bora Codar' da plataforma rocketseats."} imagem={boracodar} />
        </ul>
    )
}
